var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_2801)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67822 4.89209C5.14779 4.89209 4.63908 5.1028 4.26401 5.47788C3.88894 5.85295 3.67822 6.36166 3.67822 6.89209V22.8921C3.67822 23.2774 3.89962 23.6285 4.24736 23.7945C4.59509 23.9605 5.00728 23.912 5.30693 23.6697L9.67822 20.1356V23.8921C9.67822 24.4225 9.88894 24.9312 10.264 25.3063C10.6391 25.6814 11.1478 25.8921 11.6782 25.8921H23.377L28.0495 29.6697C28.3492 29.912 28.7614 29.9605 29.1091 29.7945C29.4568 29.6285 29.6782 29.2774 29.6782 28.8921V12.8921C29.6782 12.3617 29.4675 11.853 29.0924 11.4779C28.7174 11.1028 28.2087 10.8921 27.6782 10.8921H23.6782V6.89209C23.6782 6.36166 23.4675 5.85295 23.0924 5.47788C22.7174 5.1028 22.2087 4.89209 21.6782 4.89209H5.67822ZM21.6782 11.8921V6.89209L5.67822 6.89209L5.67822 20.7977L8.99701 18.1145C9.17497 17.9706 9.39688 17.8921 9.62572 17.8921H10.6782H21.6782V11.8921ZM11.6782 19.8921H21.6782C22.2087 19.8921 22.7174 19.6814 23.0924 19.3063C23.4675 18.9312 23.6782 18.4225 23.6782 17.8921V12.8921H27.6782V26.7977L24.3594 24.1145C24.1815 23.9706 23.9596 23.8921 23.7307 23.8921H11.6782V19.8921Z",
    fill: "url(#paint0_linear_191_2801)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_2801",
    x1: 3.67822,
    y1: 5.47351,
    x2: 28.7506,
    y2: 28.7699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE49D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FED961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FEE180"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FFE99D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFCA47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_2801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.678223 0.89209)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/Chats.69ac018d46df495c9da886f731a3402d.svg";
export { ForwardRef as ReactComponent };